import app from 'flarum/forum/app';
import {extend} from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import LinkButton from 'flarum/common/components/LinkButton';
import UserPage from 'flarum/forum/components/UserPage';
import StorePage from "./components/pages/StorePage";
import MyCartPage from "./components/pages/MyCartPage";

app.initializers.add('mattoid/store', () => {
  app.routes.store = {
    path: '/store',
    component: StorePage,
  };
  app.routes.myCartPage = {
    path: '/u/:username/cart',
    component: MyCartPage,
  };

  extend(UserPage.prototype, 'navItems', function(items) {
    // “购买记录”仅本人或论坛管理员可见。
    // canStoreCartView 由后端按“当前访问者”计算（本人或管理员才为 true），
    // 这里不再依据“当前登录者能否逛店”判断，避免把入口暴露给其他用户。
    if (!app.session || !app.session.user || !this.user || !this.user.attribute('canStoreCartView')) {
      return false;
    }

    items.add('myCartPage', LinkButton.component({
      href: app.route('myCartPage', {
        username: this.user.slug(),
      }),
      icon: 'fas fa-shopping-cart',
    }, app.translator.trans('mattoid-store.forum.cart')));
  });

  extend(IndexPage.prototype, 'navItems', function (items) {
    if (!app.session || !app.session.user || !app.session.user.attribute('canStoreView')) {
      return false;
    }

    items.add('store', LinkButton.component({
      href: app.route('store'),
      icon: 'fas fa-store',
    }, app.forum.attribute("storeName") || app.translator.trans('mattoid-store.forum.tital')));
  });
});
